import { Close } from '@mui/icons-material'
import { Box, Button, Dialog, IconButton, Typography, useTheme } from '@mui/material'
import React from 'react'
import { font } from '../../styles/font'
import { useTranslation } from 'react-i18next';

export default function DeleteProjectDialog({ open, handleClose, handleConfirm, data }) {
    const { t } = useTranslation('translation', { keyPrefix: 'project' });
    const theme = useTheme();

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleConfirm();
    }

    // Determine button text color based on theme mode
    const getButtonTextColor = () => {
        return theme.palette.mode === 'light' ? '#ffffff' : '#000000';
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onKeyDown={handleKeyDown}
            sx={{ "& .MuiDialog-paper": { width: "100%", maxWidth: "400px" } }}
        >
            <Box className="flex flex-col gap-4 px-4 py-2">
                <Box className="flex items-center justify-between gap-4">
                    <Typography 
                        fontSize={font.size.fs_4} 
                        color={theme.palette.primary.main}  // Primary color for header
                    >
                        {t("deleteTitleText")}
                    </Typography>
                </Box>

                <Box className="flex items-center gap-1">
                    <Typography 
                        fontSize={font.size.fs_4} 
                        color={theme.palette.text.secondary}
                    >
                        {`${t("deleteDescriptionText")}`}:
                    </Typography>
                    <Typography 
                        fontSize={font.size.fs_4} 
                        color={theme.palette.warning.main}  // Use warning color for project name
                    >
                        {`${data?.name}`}
                    </Typography>
                </Box>

                <Box className="flex items-center justify-end gap-4">
                    <Button 
                        onClick={handleClose}
                        sx={{
                            backgroundColor: theme.palette.error.main,
                            color: getButtonTextColor(),  // White in light, black in dark
                            '&:hover': {
                                backgroundColor: theme.palette.error.main,
                            }
                        }}
                    >
                        {t("cancelText")}
                    </Button>
                    <Button 
                        onClick={handleConfirm}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: getButtonTextColor(),  // White in light, black in dark
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main,
                            }
                        }}
                    >
                        {t("continueText")}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    )
}